import React, { useEffect, useRef } from 'react'
import { Flex, Text, Button, useModal, Skeleton } from '@pixel-nft/uikit'
import styled from 'styled-components'
import BigNumber from 'bignumber.js'
import { useTranslation } from 'contexts/Localization'
import NotEnoughTokensModal from '../Modals/NotEnoughTokensModal'
import StakeModal from '../Modals/StakeModal'
// import { chain } from 'lodash'

const InlineText = styled(Text)`
  display: inline;
`

const StakeAction: React.FC<{
  isPxf?: boolean
  poolId: number
  stakingTokenBalance: BigNumber
  isLoading?: boolean
  buttonDisabled?: boolean
}> = ({ isPxf = false, poolId, stakingTokenBalance, isLoading = false, buttonDisabled = false }) => {
  const { t } = useTranslation()

  const [onPresentTokenRequired] = useModal(<NotEnoughTokensModal tokenSymbol={isPxf ? 'PXF' : 'USDT'} />)

  const [onPresentStake] = useModal(
    <StakeModal isPxf={isPxf} poolId={poolId} stakingTokenBalance={stakingTokenBalance} />,
  )

  const renderStakeAction = () => {
    return (
      <Button onClick={stakingTokenBalance.gt(0) ? onPresentStake : onPresentTokenRequired} disabled={buttonDisabled}>
        {isPxf ? 'PXF' : 'USDT'} {t('Deposit')}
      </Button>
    )
  }

  return <Flex flexDirection="column">{isLoading ? <Skeleton width="100%" height="52px" /> : renderStakeAction()}</Flex>
}

export default StakeAction
